import { getCookies } from "./cookieToken";

const SUPPORTED = new Set(["zh", "en", "ja"]);

/**
 * 從 cookie `personal_setting` 解析 UI 語系代碼（與登入 / 切換客戶回傳、設定頁一致）
 * 處理 universal-cookie 讀寫、或字串化 JSON 等格式
 */
export function getUILanguageFromPersonalSettingCookie() {
  try {
    const raw = getCookies("personal_setting");
    if (raw == null) return null;
    const obj = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!obj || typeof obj !== "object") return null;
    const lang = obj.language;
    if (lang == null || typeof lang !== "string") return null;
    const lower = lang.trim().toLowerCase();
    const code = lower.split("-")[0];
    if (SUPPORTED.has(code)) return code;
    return null;
  } catch {
    return null;
  }
}

function baseLanguageCode(lng) {
  if (lng == null || typeof lng !== "string") return "";
  return lng.split("-")[0].toLowerCase();
}

/**
 * 若 cookie 內個人設定的語系與 i18n 不同則切換（用於登入成功後未整頁重載等情況）
 * @param {{ changeLanguage: (code: string) => void, language: string }} i18n
 */
export function applyUILanguageToI18nIfNeeded(i18n) {
  const fromCookie = getUILanguageFromPersonalSettingCookie();
  if (!fromCookie) return;
  if (baseLanguageCode(i18n.language) === fromCookie) return;
  i18n.changeLanguage(fromCookie);
}
